export default {

  CONFIG: {
    tokenExpiredRedirectRouteName: 'ProductTypeSelect'
  }

}